/** What to show a person when something failed. */
export function message(error: unknown): string {
  return error instanceof Error ? error.message : String(error);
}
